import React, {useEffect, useState} from "react";
import PageHeaderLayout from "../../../../layout/pageHeaderLayout";
import StandardTable from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from "../../../../apis/platforms/admin/expressFreight"
import {Button, Divider, message, Space, Tag} from "antd";
import withAuth from "../../../../utils/withAuth";
import {useHistory} from "react-router-dom";
import useFormModal from "../../../../utils/useFormModal";
import AddModal from "./addModal";
import {useRequest} from "ahooks";
import dayjs from "dayjs";
import {useSelector} from "react-redux";
import {RootState} from "../../../../models";

const AddButton = withAuth('add', Button)

export default function ExpressFreight() {

    const history = useHistory()
    const {BillingRule} = useSelector<RootState, RootState['dict']>(state => state.dict);
    const {refresh, tableProps} = useAntTable(api.getExpressFreight, {})

    const {modalProps, setVisible} = useFormModal({
        onRequest: api.addExpressFreight,
        onOk: (values) => {
            refresh()
            setVisible(false)
        }
    })

    const {run: switchStatus} = useRequest(api.switchStatus, {
        manual: true,
        onSuccess: () => {
            message.success("操作成功")
            refresh()
        }
    })

    const columns = [
        {
            title: '快递',
            width: 150,
            dataIndex: 'express'
        },
        {
            title: '计费规则',
            width: 150,
            dataIndex: 'rule',
            render: (value: any) => BillingRule[value]
        },
        {
            title: '规则描述',
            dataIndex: 'ruleDesc',
            render: (_: any, record: any) => {
                if (record.rule === 'weight')
                    return '首重价格+续重单价*Roundup{(订单重量-首重)/续重}'
                else if (record.rule === 'box') {
                    return '单箱价格*Roundup(商品数量/箱的基数)'
                }
            }
        },
        {
            title: '修改日期',
            width: 200,
            dataIndex: 'updateTime',
            render: (value: any, record: any) => {
                if (value)
                    return dayjs(value).format('YYYY-MM-DD HH:mm:ss')
                else
                    return dayjs(record.createTime).format('YYYY-MM-DD HH:mm:ss')
            }
        },
        {
            title: '修改人',
            width: 150,
            dataIndex: 'updateName',
            render: (value: any, record: any) => {
                if (value)
                    return value
                else
                    return record.createName
            }
        },
        {
            title: '状态',
            width: 150,
            dataIndex: 'status',
            render(value: boolean) {
                return value ? <Tag color={"green"}>已启用</Tag> : <Tag color={"red"}>已停用</Tag>
            }
        },
        {
            title: '操作',
            width: 200,
            dataIndex: 'operation',
            render: (_: any, record: any) => (
                <span>
                    {!record.fixed && (
                        <>
                            <a onClick={() => {
                                history.push(`/contract/expressFreight/detailPage/${record.id}`,)
                            }}>运费详情</a>
                            <Divider type={"vertical"}/>
                            <a onClick={() => switchStatus(record.id)}>{record.status ? '停用' : '启用'}</a>
                        </>
                    )}
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={
                <Space>
                    <AddButton type={'primary'}
                               onClick={() => setVisible(true)}>新增</AddButton>
                </Space>
            }/>
            <AddModal destroyOnClose={true} {...modalProps} title={'创建快递运费'}/>
        </PageHeaderLayout>
    )
}